import React, { useState, useEffect } from 'react';
import FullCalendar from '@fullcalendar/react'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction';
import svLocale from '@fullcalendar/core/locales/sv';
import EditOrAddEventModal from './EditOrAddEventModal';
import {
    Container, Row, Col, Dropdown, Button
} from 'react-bootstrap';
import moment from 'moment';
moment.locale('sv');

function Calendar(props) {

    const [editingEvent, setEditingEvent] = useState(null);
    const [newEventDate, setNewEventDate] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [isAdding, setIsAdding] = useState(false);
    const [bookingTypes, setBookingTypes] = useState([]);
    const [users, setUsers] = useState([]);
    const [userId, setUserId] = useState(-1);
    const [userName, setUserName] = useState("Alla");
    const [cachePolicy, setCachePolicy] = useState("no-store");
    const [hiddenDays, setHiddenDays] = useState([6, 0]);

    useEffect(() => {
        const fetchBookingTypes = async () => {
            const query = `/api/bookingTypes`;
            const res = await fetch(query,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    credentials: 'include',
                    cors: 'cors'
                });
            const resJson = await res.json();
            setBookingTypes(resJson);
            
        }
        const fetchUsers = async () => {
            const query = `/api/users`;
            const res = await fetch(query,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    credentials: 'include',
                    cors: 'cors'
                });
            const resJson = await res.json();
            setUsers(resJson);
            
        }
        fetchBookingTypes();
        fetchUsers();
    }, []);

    const eventTimeFormat = {
        hour: '2-digit',
        minute: '2-digit',
        omitZeroMinute: true,
        meridiem: false
    }

    function onBookingSaved() {
        setIsAdding(false);
        setIsEditing(false);
        setCachePolicy("no-store");
    }

    function onBookingDeleted() {
        setIsAdding(false);
        setIsEditing(false);
        setCachePolicy("no-store");
    }

    function onModalClosed() {
        setIsAdding(false);
        setIsEditing(false);
    }

    function toggleShowWeekend() {
        if (hiddenDays.length === 0) {
            setHiddenDays([6, 0]);
        }
        else {
            setHiddenDays([]);
        }
    }

    function showWeekendButtonLabel() {
        if (hiddenDays.length === 0) {
            return 'Dölj helg';
        }
        else {
            return 'Visa helg';
        }
    }

    function onUserIdSelected(eventKey, _) {
        setUserId(eventKey);
        if (eventKey.toString() === "-1") {
            setUserName("Alla");
        }
        users.forEach(user => {
            if (user.UserId.toString() === eventKey.toString()) {
                setUserName(user.Initials);
            }
        });
    }
    if (!props.shown) {
        return <React.Fragment />;
    }
    else {
        return (
            <React.Fragment>
                <Container style={{marginBottom: '10px'}}>
                    <Row className="align-items-center justify-content-center">
                        <Col xs={7}>
                            Filtrera på anvädare
                        </Col>
                        <Col xs={5}>
                            <Dropdown className="mx-sm-2" onSelect={onUserIdSelected}>
                                <Dropdown.Toggle id="dropdown-types">
                                    {userName}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item key={-1} eventKey={-1}>Alla</Dropdown.Item>
                                    {users.map((user) => (
                                        <Dropdown.Item key={user.UserId} eventKey={user.UserId}>{user.Initials}</Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </Col>
                    </Row>
                    <hr />
                    <Row className="align-items-center justify-content-center">
                        <Col xs={3}>
                        </Col>
                        <Col xs={6}>
                        <Button onClick={toggleShowWeekend} >
                            {showWeekendButtonLabel()}
                        </Button>  
                        </Col>
                        <Col xs={3}>
                        </Col>
                    </Row>    
                </Container>
                <hr />
                <FullCalendar
                    timeZone='Europe/Stockholm'
                    plugins={[ timeGridPlugin, interactionPlugin ]}
                    initialView={'timeGridWeek'}
                    slotDuration='00:15:00'
                    slotLabelFormat={{
                        hour: 'numeric',
                        minute: '2-digit',
                        omitZeroMinute: false,
                        meridiem: 'short'
                    }}
                    headerToolbar={{
                        left: 'title',
                        center: '',
                        right: 'today prev,next,timeGridDay,timeGridWeek'
                    }}
                    locale={svLocale}
                    events={fetchEvents}
                    eventTimeFormat={eventTimeFormat}
                    eventClick={editEvent}
                    eventDrop={eventDrop}
                    // Enable drag and drop
                    editable={true}
                    // Disable resize through drag
                    eventDurationEditable={false}
                    eventTextColor="#000"
                    allDaySlot={false}
                    height="auto"
                    dateClick={newEvent}
                    // Hide weekend
                    hiddenDays={hiddenDays}
                    nowIndicator={true}
                    displayEventTime={false}
                    stickyHeaderDates={true}
                />
                <EditOrAddEventModal
                    show={isEditing || isAdding}
                    isEditing={isEditing}
                    isAdding={isAdding}
                    editingEvent={editingEvent}
                    newEventDate={newEventDate}
                    bookingTypes={bookingTypes} 
                    users={users}
                    onSaved={onBookingSaved}
                    onClosed={onModalClosed}
                    onDelete={onBookingDeleted} 
                    // Current selected pet
                    petId={props.petId}
                    petName={props.petName} />
            </React.Fragment>
        );
    }

    function eventDrop(eventDropInfo) {
        const query = `/api/booking`;
        const method = 'PUT';
        const oldEvent = eventDropInfo.oldEvent;
        const newEvent = eventDropInfo.event;
        console.log(`old: ${JSON.stringify(oldEvent)}, new: ${JSON.stringify(newEvent)}`);
        fetch(query,
            {
                method: method,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                cors: 'cors',
                body: JSON.stringify({
                    bookingId: oldEvent.id,
                    start: newEvent.start,
                    end: newEvent.end,
                    bookingTypeId: oldEvent.extendedProps.bookingTypeId,
                    description: oldEvent.extendedProps.description,
                    userId: oldEvent.extendedProps.userId,
                    petId: oldEvent.extendedProps.connectedPet?.petId
                })
            }).then(res => {
                if (res.status !== 200) {
                    res.json().then((resJson) => {
                        alert('Fel vid sparning: ' + resJson.error);
                        return;
                    });
                }
            }).catch(err => {
                alert('Fel vid sparning: ' + err);
                return;
            }
        );        
    }

    function newEvent(dateInfo) {
        setIsAdding(true);
        setNewEventDate(dateInfo.date);
    }

    function editEvent(eventInfo) {
        setEditingEvent(eventInfo.event);
        setIsEditing(true);
    }

    function fetchEvents(info, successCallback, failureCallback) {
        const query = `/api/bookings`;
        fetch(query,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                cors: 'cors',
                cache: cachePolicy,
                body: JSON.stringify({
                    start: info.start,
                    end: info.end,
                    userId: userId
                })
            }).then(res => {
                if (res.status === 200) {
                    res.json().then(json => {
                        setCachePolicy("default");
                        successCallback(json);
                    });
                }
                else {
                    failureCallback();
                }
            }).catch(err => {
                failureCallback(err);
            }
        );
    }

}

export default Calendar;